import { render, staticRenderFns } from "./DealerCreditEntryDetail.vue?vue&type=template&id=35a0f818&scoped=true"
import script from "./DealerCreditEntryDetail.vue?vue&type=script&lang=js"
export * from "./DealerCreditEntryDetail.vue?vue&type=script&lang=js"
import style0 from "./DealerCreditEntryDetail.vue?vue&type=style&index=0&id=35a0f818&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35a0f818",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/flexiquote/flexiquote/uniqms-vue-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('35a0f818')) {
      api.createRecord('35a0f818', component.options)
    } else {
      api.reload('35a0f818', component.options)
    }
    module.hot.accept("./DealerCreditEntryDetail.vue?vue&type=template&id=35a0f818&scoped=true", function () {
      api.rerender('35a0f818', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/dealercreditentry/DealerCreditEntryDetail.vue"
export default component.exports